import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createGetCurrentApplicationThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(ApplicationProcessActionTypes.GetCurrentApplication, async () => {
    const response = await api.getCurrentApplication();
    return response;
  });
